import {
  Component,
  OnInit,
  Input,
  ViewChild,
  Output,
  EventEmitter
} from '@angular/core';
import { SignaturePad } from 'angular2-signaturepad/signature-pad';

@Component({
  selector: 'signature-question',
  templateUrl: './signature-question.component.html',
  styleUrls: ['./signature-question.component.less']
})
export class SignatureQuestionComponent implements OnInit {
  @Input() question: any;
  @ViewChild(SignaturePad) signaturePad: any;
  @Output() answered: EventEmitter<any> = new EventEmitter();
  @Output() answerCleared: EventEmitter<any> = new EventEmitter();
  @Output() modified: EventEmitter<any> = new EventEmitter();
  hasAnswer: boolean = false;
  signaturePadOptions: any = {
    onEnd: this.drawComplete,
  }

  ngOnInit() {
    if (this.question.rows[0].value)
      this.hasAnswer = true;
  }

  ngAfterViewInit() {
    // this.signaturePad is now available
    this.setSize();
    if (this.question.rows[0].value)
      this.signaturePad.fromDataURL(this.question.rows[0].value);
  }

  setSize() {
    let canvas = this.signaturePad.signaturePad._canvas;
    let ratio =  Math.max(window.devicePixelRatio || 1, 1);
    canvas.width = canvas.offsetWidth * ratio;
    canvas.height = canvas.offsetHeight * ratio;
    canvas.getContext("2d").scale(ratio, ratio);
  }

  clear() {
    this.signaturePad.clear();
    this.question.rows[0].value = '';
    this.hasAnswer = false;
    this.answerCleared.emit(null);
    this.modified.emit(null);
  }

  drawComplete() {
    this.question.rows[0].value = this.signaturePad.toDataURL();

    if (!this.hasAnswer) {
      this.hasAnswer = true;
      this.answered.emit(null);
    }

    this.modified.emit(null);
  }
}



// WEBPACK FOOTER //
// ./src/app/survey/signature-question/signature-question.component.ts